<div
    class="flex h-full flex-col p-8"
    [class.surface-card]="surfaceVariant === 'default'"
    [class.surface-card-strong]="surfaceVariant === 'strong'"
>
    <ng-content></ng-content>
    @if (buttonList.length > 0) {
        <div class="flex flex-col flex-wrap gap-1 pt-3 lg:flex-row">
            @for (button of buttonList; track getModelId($index, button)) {
                <button
                    type="button"
                    [ngClass]="[button.buttonStyle]"
                    (click)="buttonClicked(button)"
                    (keypress)="buttonClicked(button)"
                    [disabled]="button.disabled"
                    appRestrictedAccess
                    [model]="button.permissionModel"
                    [actions]="button.permissionActions"
                >
                    @if (button.icon) {
                        <fa-icon [icon]="button.icon"></fa-icon>
                    }
                    {{ button.title }}
                </button>
            }
        </div>
    }
</div>
